import $axios from "@/utils/axios.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  GetProvider(context, params) {
    // endpoint hanya terima page & pageSizes, id dipakai di path
    const { id, ...query } = params;
    this.state.isLoading = true;
    return new Promise((resolve, reject) => {
      $axios
        .get("/provider/" + id, {
          params: {
            ...query,
          },
        })
        .then((response) => {
          this.state.isLoading = false;
          resolve(response);
        })
        .catch((error) => {
          this.state.isLoading = false;
          reject(error);
        });
    });
  },
};

export default {
  namespace: true,
  state,
  getters,
  mutations,
  actions,
};
